import type { WireArticleBlock } from '../../../api/types'

// Textbox can contain child blocks — forward declare renderer to avoid circular dep
// ArticleRenderer passes its block renderer as a render prop.
type Block = Extract<WireArticleBlock, { type: 'textbox' }>

interface TextboxBlockProps {
  block: Block
  renderBlock?: (child: WireArticleBlock) => React.ReactNode
}

export function TextboxBlock({ block, renderBlock }: TextboxBlockProps) {
  return (
    <aside className="space-y-3 rounded border border-line bg-fill px-5 py-4">
      {block.title && (
        <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-fg-secondary">
          {block.title}
        </p>
      )}
      <div className="space-y-3">
        {block.children.map((child) => (
          <div key={child.id}>{renderBlock?.(child)}</div>
        ))}
      </div>
    </aside>
  )
}
